export const enum PageDataType {
  INVOICES = 'invoices',
  PAYMENTS = 'payments',
}
